import React, { useState, useEffect } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams } from "react-router-dom";
import { format } from "date-fns";
import { config, priceFormat, shortenUrl } from "./Components/Config";
import './print.css';

const InvoiceRequestPrint = () => {
  const { id_iou } = useParams();
  const [iou, setIou] = useState(null);
  const [iouItems, setIouItems] = useState(null);
  const [quotationItems, setQuotationItems] = useState(null);
  useEffect(() => {
    if (id_iou) {
      getIou();
      getIouItems();
    }
  }, [id_iou]);

  useEffect(() => {
    if (iou) {
			getQuotationItems();
      document.title = 'Invoice Request ' + iou.iou_code;
    }
  }, [iou]);

  useEffect(() => {
    if (iouItems) {
			window.print();
    }
  }, [iouItems]);

  const getIou = async () => {
    try {
      const fetchIou = await jwtFetch(config.ENDPOINT + 'get/iou', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_iou: id_iou
        })
      });
      const responseIou = await fetchIou.json();
      if (responseIou.status === 200) {
        setIou(responseIou.data[0]);
      } else {
        alert(responseIou.message);
      }
    } catch (error) {
      console.error('Error fetching iou:', error);
    }
  };

  const getIouItems = async () => {
    try {
      const fetchIouItems = await jwtFetch(config.ENDPOINT + 'get/iou_item', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          iou_id: id_iou
        })
      });
      const responseIouItems = await fetchIouItems.json();
      if (responseIouItems.status === 200) {
				const newIouItems = [];
				for (let i in responseIouItems.data) {
					let newIouItem = responseIouItems.data[i];
					const companyLicence = await getCompanyLicence(responseIouItems.data[i].company_id, responseIouItems.data[i].product_id, responseIouItems.data[i].product_domain);
					if (companyLicence) {
						newIouItem.licence_start_period = companyLicence.licence_start_period;
						newIouItem.licence_end_period = companyLicence.licence_end_period;
					}
					newIouItems.push(newIouItem);
				}
        setIouItems(newIouItems);
      } else {
        alert(responseIouItems.message);
      }
    } catch (error) {
      console.error('Error fetching iou items:', error);
    }
  };

  const getQuotationItems = async () => {
    try {
      const fetchQuotationItems = await jwtFetch(config.ENDPOINT + 'get/quotation_item', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          quotation_id: iou.quotation_id
        })
      });
      const responseQuotationItems = await fetchQuotationItems.json();
      if (responseQuotationItems.status === 200) {
        setQuotationItems(responseQuotationItems.data);
      } else {
        alert(responseQuotationItems.message);
      }
    } catch (error) {
      console.error('Error fetching quotation items:', error);
    }
  };

  const getCompanyLicence = async (companyId, productId, licenceDomain) => {
    try {
      const requestCompanyLicence = {
        "company_id": companyId,
        "product_id": productId,
        "licence_domain": licenceDomain,
      }
      const fetchCompanyLicence = await jwtFetch(config.ENDPOINT + 'get/clients_company_licence', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestCompanyLicence)
      });
      const responseCompanyLicence = await fetchCompanyLicence.json();
      if (responseCompanyLicence.status === 200) {
        if (responseCompanyLicence.data.length > 0) {
          return responseCompanyLicence.data[0];
        } else {
          return null;
        }
      } else {
        alert(responseCompanyLicence.message);
      }
    } catch (error) {
      console.error('Error in getCompanyLicence:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  return (
    <div>
      {(iou && iouItems) ? (
		<div>
          <div className="invoice-container-landscape">
            <div className="invoice-header">
							<div className="bg-success text-white text-center p-2 mb-4">
								<p className="fs-18 strong mb-0">REQUEST TO ISSUE INVOICE</p>
							</div>
              <div className="row align-items-end justify-content-center mb-4">
								<div className="col-4">
									<img src="/pointstar.png" width={150} alt="PointStar"/>
								</div>
								<div className="col-8">
									<div className="row mb-1 g-2 justify-content-center">
										<div className="col-5 text-end"><strong>No Invoice Request</strong><span className="ms-1">:</span></div>
										<div className="col-5">{iou.iou_code}</div>
									</div>
									<div className="row mb-1 g-2 justify-content-center">
										<div className="col-5 text-end"><strong>Tanggal Invoice Request</strong><span className="ms-1">:</span></div>
										<div className="col-5">{format(new Date(iou.created_on), 'd MMMM yyyy')}</div>
									</div>
                </div>
              </div>
              <div className="row mb-2">
								<div className="col-3"><strong>Pilar</strong></div>
								<div className="col-9">
									<div className="d-flex">
										<span className="me-4">:</span>
										<span>{iouItems[0].product_type}</span>
									</div>
								</div>
							</div>
							<div className="row mb-2">
								<div className="col-3"><strong>Deal Type</strong></div>
								<div className="col-9">
									<div className="d-flex">
										<span className="me-4">:</span>
										<span>{iouItems[0].service_type}</span>
									</div>
								</div>
							</div>
              <div className="row mb-4">
								<div className="col-3"><strong>Dokumen Penagihan</strong></div>
								<div className="col-9">
									<div className="d-flex">
										<span className="me-4">:</span>
										<div className="d-flex gap-5">
											{JSON.parse(iou.request_invoice_documents).map((document, d) => (
												<div key={"document-" + d}>
													<i className="bi bi-check-square me-2"/>
													<span>{document}</span>
												</div>
											))}
										</div>
									</div>
								</div>
							</div>
              <div className="row mb-2">
								<div className="col-12"><strong>BILLING TO</strong></div>
							</div>
              <div className="row mb-4">
								<div className="col-12">
									<div className="row mb-2">
										<div className="col-3 ps-5"><strong>Nama Perusahaan</strong></div>
										<div className="col-9">
											<div className="d-flex">
												<span className="me-4">:</span>
												<div>{iou.subcompany_billing_name}</div>
											</div>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-3 ps-5"><strong>Alamat</strong></div>
										<div className="col-9">
											<div className="d-flex">
												<span className="me-4">:</span>
												<div>{iou.subcompany_billing_address}</div>
											</div>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-3 ps-5"><strong>No NPWP</strong></div>
										<div className="col-9">
											<div className="d-flex">
												<span className="me-4">:</span>
												<div>{iou.subcompany_npwp_number}</div>
											</div>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-3 ps-5"><strong>Telpon Customer</strong></div>
										<div className="col-9">
											<div className="d-flex">
												<span className="me-4">:</span>
												<div>{iou.subcompany_phone}</div>
											</div>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-3 ps-5"><strong>Fax No</strong></div>
										<div className="col-9">
											<div className="d-flex">
												<span className="me-4">:</span>
												<div>{iou.subcompany_fax}</div>
											</div>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-3 ps-5"><strong>Nomor Quotation</strong></div>
										<div className="col-9">
											<div className="d-flex">
												<span className="me-4">:</span>
												<div>{iou.quotation_code}</div>
											</div>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-3 ps-5"><strong>Tanggal Mulai Penagihan</strong></div>
										<div className="col-9">
											<div className="d-flex">
												<span className="me-4">:</span>
												<div>{format(new Date(iou.start_term_period), 'd MMMM yyyy')}</div>
											</div>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-3 ps-5"><strong>Kurs untuk ATB ini</strong></div>
										<div className="col-9">
											<div className="d-flex">
												<span className="me-4">:</span>
												<div>{priceFormat(iou.iou_exchange_rate, iou.iou_currency)}</div>
												<div className="ms-4">
													<i className={"bi bi-" + (iou.iou_exchange_floating === 'Floating' ? 'check-square' : 'square') + " me-2"}/>
													<span>Floating</span>
												</div>
											</div>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-3 ps-5"><strong>Nature of Billing Issuence</strong></div>
										<div className="col-9">
											<div className="d-flex">
												<span className="me-4">:</span>
												<div>
													{quotationItems && (
														quotationItems[0].billing_payment_term === 'Installment' ? (
															quotationItems[0].billing_payment_term + " (" + quotationItems[0].billing_payment_period + ")"
														) : 'One Time'
													)}
												</div>
											</div>
										</div>
									</div>
									<div className="row mb-2">
										<div className="col-3 ps-5"><strong>Penagihan ke</strong></div>
										<div className="col-9">
											<div className="d-flex">
												<span className="me-4">:</span>
												<div>{iou.term_number.replace('Term ', '') + " dari " + iou.term_count}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
              <div className="row mb-2">
								<div className="col-12"><strong>DETAIL/DESCRIPTION OF BILLING</strong></div>
							</div>
              <div className="row mb-4">
								<div className="col-12 ps-5">
									<div className="table-responsive">
										<table className="items-table mb-4">
											<thead>
												<tr>
													<th style={{textAlign: 'center'}}>No</th>
													<th style={{textAlign: 'center'}}>Deskripsi</th>
													<th style={{textAlign: 'center'}}>Jumlah</th>
													<th style={{textAlign: 'center'}}>Unit 1</th>
													<th style={{textAlign: 'center'}}>Mata Uang</th>
													<th style={{textAlign: 'center'}}>Harga</th>
													<th style={{textAlign: 'center'}}>Bulan</th>
													<th className="w-150" style={{textAlign: 'center'}}>Harga Satuan (IDR)</th>
													<th className="w-150" style={{textAlign: 'center'}}>Total Billing</th>
												</tr>
											</thead>
											<tbody>
												{iouItems && iouItems.map((item, i) => (
													<tr key={i}>
														<td valign="top" style={{textAlign: 'center'}}>{i + 1}</td>
														<td valign="top">
															<div className="row mb-1">
																<div className="col-4">SKU Name</div>
																<div className="col-8">
																	<div className="d-flex">
																		<span className="me-2">:</span>
																		<div>{item.product_name}</div>
																	</div>
																</div>
															</div>
															{item.product_display_description && item.product_display_description.split('\n').map((description, d) => (
																<div className="row mb-1" key={"description-" + d}>
																	{description.split(':').length > 1 ? (
																		<div className="col-4">{description.split(':')[0].trim()}</div>
																	) : (
																		<div className="col-12">{description.trim()}</div>
																	)}
																	{description.split(':').length > 1 && (
																		<div className="col-8">
																			<div className="d-flex">
																				<span className="me-2">:</span>
																				<div>{description.split(':').slice(1).join(':').trim()}</div>
																			</div>
																		</div>
																	)}
																</div>
															))}
														</td>
														<td valign="top" style={{textAlign: 'center'}}>{item.product_qty}</td>
														<td valign="top" style={{textAlign: 'center'}}>Unit</td>
														<td valign="top" style={{textAlign: 'center'}}>{item.product_currency_original === 'IDR' ? 'Rupiah' : 'Non-Rupiah'}</td>
														<td valign="top" style={{textAlign: 'right'}}>{priceFormat(item.product_price_original, item.product_currency_original)}</td>
														<td valign="top" style={{textAlign: 'center'}}>{item.contract_long_period}</td>
														<td valign="top" style={{textAlign: 'right'}}>{priceFormat(item.product_price, item.product_currency)}</td>
														<td valign="top" style={{textAlign: 'right'}}>
															{item.product_discount_price && item.product_discount_price !== '0.00' ? (
																<div>
																	<span className="text-strike text-danger">{priceFormat(item.product_subtotal, item.product_currency)}</span>
																	<br/>
																	<span>{priceFormat(item.product_grand_total, item.product_currency)}</span>
																</div>
															) : (
																<span>{priceFormat(item.product_grand_total, item.product_currency)}</span>
															)}
														</td>
													</tr>
												))}
												<tr>
													<td colSpan={8} style={{textAlign: 'center'}}>
														<strong>TOTAL TAGIHAN</strong>
													</td>
													<td style={{textAlign: 'right'}}>
														{priceFormat(iou.iou_subtotal, iou.iou_currency)}
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
              <div className="row mb-2">
								<div className="col-3"><strong>Referensi & Lampiran</strong></div>
								<div className="col-9">
									<div className="d-flex">
										<span className="me-4">:</span>
										<div className="w-100">
											{iou.request_invoice_attachments && JSON.parse(iou.request_invoice_attachments).map((attachment, a) => (
												<div className="row mb-2" key={"attachment-" + a}>
													<div className="col-3">
														<i className="bi bi-check-square me-2"/>
														<span>{attachment.name}</span>
													</div>
													<div className="col-3">
														<i className="bi bi-check-square me-2"/>
														<span>{attachment.status}</span>
													</div>
													{attachment.files && (
														<div className="col-6">
															<a href={attachment.files[0].fileUrl} target="_blank" rel="noopener noreferrer">{shortenUrl(attachment.files[0].fileUrl, 40)}</a>
														</div>
													)}
												</div>
											))}
										</div>
									</div>
								</div>
							</div>
              <div className="row mb-2">
								<div className="col-3"><strong>Invoice delivery to</strong></div>
								<div className="col-9">
									<div className="d-flex">
										<span className="me-4">:</span>
										<div>{iou.subcompany_address}</div>
									</div>
								</div>
							</div>
              <div className="row mb-5">
								<div className="col-3"><strong>NOTES</strong></div>
								<div className="col-9">
									<div className="d-flex">
										<span className="me-4">:</span>
										<div>{iou.request_invoice_remarks}</div>
									</div>
								</div>
							</div>
            </div>

            <div className="terms-section">
              <p className="pb-5">* This invoice request is auto-generated by CuanCuan system. No signature is required.</p>
            </div>
          </div>
        </div>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
};

export default InvoiceRequestPrint;

